"use client";

import Footer from "@/components/footer.component";
import Header from "@/components/ui/header.component";
import Snackbar from "@/components/ui/snackbar.component";
import { ReactNode } from "react";

export default function ClientProvider({ children }: { children: ReactNode }) {
  return (
    <>
      <Snackbar />
      <Header />
      {children}
      <Footer />
    </>
  );
}
